var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { attrs: { id: "ueyes_app" } },
    [
      _c("LeftNavMenu"),
      _c(
        "v-main",
        { class: { min: _vm.checkDisplayPcFromMobile }, attrs: { id: "main" } },
        [_c("router-view"), _c("AutoLogout")],
        1
      ),
      _vm.mobile ? _c("Footer") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }